
import { WorldCountry } from '../types';

export const canadaExpanded: WorldCountry = {
  code: 'CA',
  name: 'Canada',
  slug: 'canada',
  population: 38000000,
  topCities: [
    // Major cities
    { name: 'Toronto', slug: 'toronto', population: 2930000 },
    { name: 'Montreal', slug: 'montreal', population: 1780000 },
    { name: 'Vancouver', slug: 'vancouver', population: 631486 },
    { name: 'Calgary', slug: 'calgary', population: 1306784 },
    { name: 'Edmonton', slug: 'edmonton', population: 981280 },
    { name: 'Ottawa', slug: 'ottawa', population: 994837 },
    { name: 'Winnipeg', slug: 'winnipeg', population: 749534 },
    { name: 'Quebec City', slug: 'quebec-city', population: 542298 },
    { name: 'Hamilton', slug: 'hamilton', population: 747545 },
    { name: 'Kitchener', slug: 'kitchener', population: 470015 },
    
    // Extended cities to reach 100
    { name: 'London', slug: 'london-canada', population: 422324 },
    { name: 'Victoria', slug: 'victoria', population: 91867 },
    { name: 'Halifax', slug: 'halifax', population: 431479 },
    { name: 'Oshawa', slug: 'oshawa', population: 175383 },
    { name: 'Windsor', slug: 'windsor', population: 229660 },
    { name: 'Saskatoon', slug: 'saskatoon', population: 273010 },
    { name: 'St. Catharines', slug: 'st-catharines', population: 140370 },
    { name: 'Regina', slug: 'regina', population: 230828 },
    { name: 'Sherbrooke', slug: 'sherbrooke', population: 172950 },
    { name: 'Kelowna', slug: 'kelowna', population: 144576 },
    { name: 'Barrie', slug: 'barrie', population: 147829 },
    { name: 'Abbotsford', slug: 'abbotsford', population: 153524 },
    { name: 'Coquitlam', slug: 'coquitlam', population: 148625 },
    { name: 'Trois-Rivières', slug: 'trois-rivieres', population: 139163 },
    { name: 'Guelph', slug: 'guelph', population: 135474 },
    { name: 'Cambridge', slug: 'cambridge-canada', population: 138479 },
    { name: 'Whitby', slug: 'whitby', population: 138501 },
    { name: 'Kingston', slug: 'kingston', population: 132485 },
    { name: 'Ajax', slug: 'ajax', population: 126666 },
    { name: 'Langley', slug: 'langley', population: 132603 },
    { name: 'Saanich', slug: 'saanich', population: 117735 },
    { name: 'Milton', slug: 'milton', population: 132979 },
    { name: 'Moncton', slug: 'moncton', population: 79470 },
    { name: 'Thunder Bay', slug: 'thunder-bay', population: 121621 },
    { name: 'Dieppe', slug: 'dieppe', population: 28114 },
    { name: 'Waterloo', slug: 'waterloo', population: 104986 },
    { name: 'Delta', slug: 'delta', population: 108455 },
    { name: 'Chatham-Kent', slug: 'chatham-kent', population: 103988 },
    { name: 'Red Deer', slug: 'red-deer', population: 100418 },
    { name: 'Kamloops', slug: 'kamloops', population: 97385 },
    { name: 'Brantford', slug: 'brantford', population: 97496 },
    { name: 'Cape Breton', slug: 'cape-breton', population: 94285 },
    { name: 'Lethbridge', slug: 'lethbridge', population: 101482 },
    { name: 'Saint-Jean-sur-Richelieu', slug: 'saint-jean-sur-richelieu', population: 95114 },
    { name: 'Clarington', slug: 'clarington', population: 92013 },
    { name: 'Pickering', slug: 'pickering', population: 99186 },
    { name: 'Nanaimo', slug: 'nanaimo', population: 90504 },
    { name: 'Sudbury', slug: 'sudbury', population: 166004 },
    { name: 'North Vancouver', slug: 'north-vancouver', population: 85935 },
    { name: 'Burlington', slug: 'burlington', population: 183314 },
    { name: 'Longueuil', slug: 'longueuil', population: 249870 },
    { name: 'Burnaby', slug: 'burnaby', population: 249125 },
    { name: 'Oakville', slug: 'oakville', population: 213759 },
    { name: 'New Westminster', slug: 'new-westminster', population: 78916 },
    { name: 'Airdrie', slug: 'airdrie', population: 74100 },
    { name: 'Mississauga', slug: 'mississauga', population: 721599 },
    { name: 'Brampton', slug: 'brampton', population: 656480 },
    { name: 'Richmond', slug: 'richmond', population: 209937 },
    { name: 'Markham', slug: 'markham', population: 338503 },
    { name: 'Vaughan', slug: 'vaughan', population: 323103 },
    { name: 'Gatineau', slug: 'gatineau', population: 276245 },
    { name: 'Laval', slug: 'laval', population: 438366 },
    { name: 'Richmond Hill', slug: 'richmond-hill', population: 195022 },
    { name: 'Newmarket', slug: 'newmarket', population: 87942 },
    { name: 'Caledon', slug: 'caledon', population: 71523 },
    { name: 'Halton Hills', slug: 'halton-hills', population: 62951 },
    { name: 'Aurora', slug: 'aurora', population: 62057 },
    { name: 'King City', slug: 'king-city', population: 27333 },
    { name: 'East Gwillimbury', slug: 'east-gwillimbury', population: 24979 },
    { name: 'Georgina', slug: 'georgina', population: 48810 },
    { name: 'Bradford West Gwillimbury', slug: 'bradford-west-gwillimbury', population: 42519 },
    { name: 'Innisfil', slug: 'innisfil', population: 37905 },
    { name: 'New Tecumseth', slug: 'new-tecumseth', population: 34242 },
    { name: 'Mono', slug: 'mono', population: 8965 },
    { name: 'Orangeville', slug: 'orangeville', population: 30734 },
    { name: 'Shelburne', slug: 'shelburne', population: 8817 },
    { name: 'Mulmur', slug: 'mulmur', population: 3783 },
    { name: 'Amaranth', slug: 'amaranth', population: 4130 },
    { name: 'Melancthon', slug: 'melancthon', population: 2929 },
    { name: 'Grand Valley', slug: 'grand-valley', population: 3171 },
    { name: 'Primrose', slug: 'primrose', population: 1250 },
    { name: 'Hornepayne', slug: 'hornepayne', population: 980 },
    { name: 'Kapuskasing', slug: 'kapuskasing', population: 8196 },
    { name: 'Hearst', slug: 'hearst', population: 5070 },
    { name: 'Cochrane', slug: 'cochrane', population: 29377 },
    { name: 'Timmins', slug: 'timmins', population: 41788 },
    { name: 'Iroquois Falls', slug: 'iroquois-falls', population: 4537 },
    { name: 'Matheson', slug: 'matheson', population: 1273 },
    { name: 'Smooth Rock Falls', slug: 'smooth-rock-falls', population: 1330 },
    { name: 'Fauquier-Strickland', slug: 'fauquier-strickland', population: 595 },
    { name: 'Moonbeam', slug: 'moonbeam', population: 1295 },
    { name: 'Val Rita-Harty', slug: 'val-rita-harty', population: 836 },
    { name: 'Opasatika', slug: 'opasatika', population: 280 },
    { name: 'Black River-Matheson', slug: 'black-river-matheson', population: 2438 },
    { name: 'Charlton and Dack', slug: 'charlton-and-dack', population: 332 },
    { name: 'Englehart', slug: 'englehart', population: 1479 },
    { name: 'Kirkland Lake', slug: 'kirkland-lake', population: 7981 },
    { name: 'Larder Lake', slug: 'larder-lake', population: 679 },
    { name: 'McGarry', slug: 'mcgarry', population: 4313 },
    { name: 'Temiskaming Shores', slug: 'temiskaming-shores', population: 9634 },
    { name: 'Coleman', slug: 'coleman', population: 570 },
    { name: 'Cobalt', slug: 'cobalt', population: 1147 },
    { name: 'Latchford', slug: 'latchford', population: 313 },
    { name: 'Temagami', slug: 'temagami', population: 802 },
    { name: 'North Bay', slug: 'north-bay', population: 51553 },
    { name: 'Mattawa', slug: 'mattawa', population: 1993 }
  ]
};
